import CardWrapper from '@components/UI/CardWrapper';
import Typography from '@mui/material/Typography';
import {
  DocumentFields,
  DocumentsData,
} from '@services/requests/companyProfileService/types/documentsData';
import React from 'react';

import { DocumentItem } from './DocumentItem';
import { DocumentsModuleStyledContainer } from './StyledComponents';

interface DocumentsModuleProps {
  Icon: () => React.JSX.Element;
  title: string;
  documents: DocumentFields;
  documentsData: DocumentsData;
  isAllowEdit: boolean;
}

function DocumentsModule({
  Icon,
  title,
  documents,
  documentsData,
  isAllowEdit,
}: DocumentsModuleProps) {
  const filteredDocuments = Object.values(documents).filter(
    (document) => document.editable || (!document.editable && !!document.value)
  );

  if (filteredDocuments.length === 0) {
    return null;
  }

  return (
    <DocumentsModuleStyledContainer>
      <CardWrapper sx={{ padding: '25px 90px 25px 40px' }} className="card">
        <Icon />
        <div className="documents-content">
          <Typography variant={'h3'} className={'module-title'}>
            {title}:
          </Typography>

          <div className="documents-list-wrapper">
            {Object.entries(documents).map(([code, document], index) => (
              <DocumentItem
                key={index}
                document={document}
                code={code}
                documentsData={documentsData}
                isAllowEdit={isAllowEdit}
              />
            ))}
          </div>
        </div>
      </CardWrapper>
    </DocumentsModuleStyledContainer>
  );
}
export { DocumentsModule };
